module.exports = __webpack_public_path__ + "static/media/Logo_Trust_EMAS.853f2702.png";